import { z } from "zod";

const envSchema = z.object({
  VITE_SUPABASE_URL: z
    .string()
    .url("VITE_SUPABASE_URL gecerli bir URL olmali")
    .optional(),
  VITE_SUPABASE_ANON_KEY: z
    .string()
    .min(1, "VITE_SUPABASE_ANON_KEY bos olamaz")
    .optional(),
  VITE_BACKEND_URL: z
    .string()
    .url("VITE_BACKEND_URL gecerli bir URL olmali")
    .optional(),
  VITE_SENTRY_DSN: z
    .string()
    .url("VITE_SENTRY_DSN gecerli bir URL olmali")
    .optional(),
});

function validateEnv() {
  const result = envSchema.safeParse({
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || undefined,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || undefined,
    VITE_BACKEND_URL: import.meta.env.VITE_BACKEND_URL || undefined,
    VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || undefined,
  });

  if (!result.success) {
    const errors = result.error.issues
      .map((issue) => `  - ${issue.path.join(".")}: ${issue.message}`)
      .join("\n");
    console.error(`[ENV] Gecersiz environment degiskenleri:\n${errors}`);
  }

  return result.success ? result.data : envSchema.parse({});
}

export const env = validateEnv();
